import OdxIcon from "./Odx-Icon";
import {odxIconSets} from "../constants";

export interface IOdxInlineMessageProps {
    variant: "success" | "danger" | "warning" | "default",
    text: string
}

/**
 * OdxInlineMessage component
 * @param variant "success" | "danger" | "warning" | "default"
 * @param text string
 * @constructor
 */
const OdxInlineMessage: React.FC<IOdxInlineMessageProps> = ({variant, text}) => {
    let icon = <></>
    switch (variant) {
        case "success":
            icon = <OdxIcon name={"check"} size={"md"} iconSet={odxIconSets.core}/>;
            break;
        case "danger":
            icon = <OdxIcon name={"error"} size={"md"} iconSet={odxIconSets.core}/>;
            break;
        case "warning":
            icon = <OdxIcon name={"warning"} size={"md"} iconSet={odxIconSets.core}/>;
            break;
        default:
            icon = <OdxIcon name={"error"} size={"md"} iconSet={odxIconSets.core}/>;
            break;
    }

    return <div className={`odx-inline-message odx-inline-message--${variant} w-fit`}>
        {icon}
        <div className={"odx-inline-message__content"}>
            {text}
        </div>
    </div>
}

export default OdxInlineMessage;